import React, { Suspense, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PeriodSelectBox from '../../../global/PeriodSelectBox';
import { fetchManufacturerTransactions } from '../../../../services/Http/ManufacturerApi';
import { Spinner } from 'reactstrap';

const ReactApexChart = React.lazy(() => import('react-apexcharts'));

const TransactionsOverview = () => {
    const { t } = useTranslation();
    const [period, setPeriod] = useState('last_12_months');
    const [chartData, setChartData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                const data = await fetchManufacturerTransactions({ period });
                setChartData(data);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [period]);

    if (loading || !chartData) {
        return (
            <Centered>
                <Spinner />
            </Centered>
        );
    }

    return (
        <Wrapper>
            <Header>
                <div>
                    <Title>{t('ManufacturerProducts.transactions.title')}</Title>
                    <Subtitle>{t('ManufacturerProducts.transactions.subtitle')}</Subtitle>
                </div>
                <PeriodSelectBox value={period} onChange={(e) => setPeriod(e.target.value)} />
            </Header>
            <Suspense fallback={<Centered><Spinner /></Centered>}>
                <ReactApexChart
                    type="area"
                    height={360}
                    series={[
                        { name: t('ManufacturerProducts.transactions.retailers'), data: chartData.retailers.values },
                        { name: t('ManufacturerProducts.transactions.customers'), data: chartData.customers.values },
                    ]}
                    options={{
                        chart: { id: 'manufacturer-transactions', toolbar: { show: false } },
                        xaxis: { categories: chartData.categories },
                        colors: ['#821692', '#0DCAF0'],
                    }}
                />
            </Suspense>
        </Wrapper>
    );
};

export default TransactionsOverview;

const Wrapper = styled.div`
    border: 1px solid rgba(130, 22, 146, 0.2);
    border-radius: 12px;
    padding: 1.25rem;
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
`;

const Title = styled.h3`
    margin: 0;
    color: rgba(130, 22, 146, 1);
`;

const Subtitle = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.textSecondary || '#666'};
`;

const Centered = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
`;
